export default "__VITE_ASSET__BAACQdAX__"